"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var element_1 = require("../../../element");
var shortcuts_1 = require("../../../utils/shortcuts");
var base_1 = require("./base");
var BarRenderer = /** @class */ (function (_super) {
    __extends(BarRenderer, _super);
    function BarRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultScaleDataKey = "bar";
        return _this;
    }
    BarRenderer.prototype.renderSection = function (section) {
        var _this = this;
        _super.prototype.renderSection.call(this, section);
        var inversed = this._getOption("inversed", false);
        this._arcs = section.appendGroupT(element_1.Arc).options({
            _data: function (d, i, g) {
                var data = _this.transformData(d).data;
                var xScale = section.parent.circos.xScaleForChr(d._key);
                var _innerR = _this._r(true, section, d._key);
                var _outerR = _this._r(false, section, d._key);
                // data
                return data.map(function (x) {
                    var _a = _this._adjustToAtLeast1Px(section, d._key, xScale(x.start), xScale(x.end)), _start = _a[0], _end = _a[1];
                    return __assign(__assign({}, x), { _start: _start, _end: _end, _r: _this._yScale[d._key](x.value), _innerR: _innerR, _outerR: _outerR });
                });
            },
            _startAngle: function (d) { return d._start; },
            _endAngle: function (d) { return d._end; },
            _padAngle: 0,
            _innerR: inversed ? shortcuts_1.attr("_r") : shortcuts_1.attr("_innerR"),
            _outerR: inversed ? shortcuts_1.attr("_outerR") : shortcuts_1.attr("_r"),
            _tooltip: function (d) { return d.data.chr + "<br>" + d.data.start + "-" + d.data.end + "<br>Copy Number: " + d.value; },
            _$mouseEnter: function () {
                this.style.opacity = "0.5";
            },
            _$mouseLeave: function () {
                this.style.opacity = "1";
            },
        });
        this.assignGOptions({ bar: "_arcs" });
        section.parent.setupProxy({
            bar: "_arcs",
        }, this);
    };
    return BarRenderer;
}(base_1.Renderer));
exports.BarRenderer = BarRenderer;
//# sourceMappingURL=bar.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/circos/layers/bar.js
// module id = 1177
// module chunks = 0 1